/**
 * MyProject has no backend-backed project file-filter fields yet. Keep the hook
 * shape for explorers, but default to an empty filter until that API exists.
 */
export type ProjectRegexKey = "rawFilesRegex" | "fastaFilesRegex" | "intermediateResultsRegex" | "settingsRegex";

export const useProjectRegexDefault = (_key: ProjectRegexKey): string => "";

export default useProjectRegexDefault;
